import { t } from './translations';

export const greetUser = (greeting: string, firstName?: string) =>
  firstName ? t(greeting, { firstName: firstName.concat(', ') }) : greeting.charAt(0).toUpperCase() + greeting.slice(1);
